"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const demo_theme_provider_with_toggle_1 = require("../demo-theme-provider-with-toggle");
const copy = {
    ko: `국군의 조직과 편성은 법률로 정한다. 모든 국민의 재산권은 보장된다. 제3항의
		승인을 얻지 못한 때에는 그 처분 또는 명령은 그때부터 효력을 상실한다.`,
    zh: `支转有点身头办局线越，越好实集调识已看，斗构杨加秧干图I。 派阶该还决真起设置火，
		列斯越历适元快积种公，属型材政报志龙将。任面受至据料连专型，族九期图素信识作王，
		般蠢镰争I英肃。意后需每段等华交三，就义论油新统快，况法8还来但。`,
    tw: `跑人日代的體理書保現可學房，找次統活同持不大當帶的自特著子好大學在老聽利教大有
		腦速意心生響年近健教點整聯期學朋友立量，比時月於本主，巴它社你青化位個動像建立克
		國善用的團，於長居。`,
    ja: `7毎記ぼリ謙球げんごレ望過ムテヲ役少防ユカヒモ併人クテ帳画ラホタ木規将ケマトル滞
		握モヱワス権来ミサ医方品りすぎラ。`,
    ar: `و سأعرض مثال حي لهذا، من منا لم يتحمل جهد بدني شاق إلا من أجل الحصول على ميزة أو فائدة؟ ولكن من لديه الحق أن ينتقد شخص ما أراد أن يشعر بالسعادة التي لا تشوبها عواقب أليمة أو آخر أراد أن يتجنب الألم الذي ربما تنجم عنه بعض المتعة ؟ `,
    en: `Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet
		incidunt aut voluptatum autem voluptates ea numquam cupiditate
		deleniti unde.`
};
exports.DemoPlaceholderText = () => (React.createElement(demo_theme_provider_with_toggle_1.DemoThemeProviderToggleContext.Consumer, null, value => copy[value.language || 'en'] || copy.en));
